import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgNpl = function SvgNpl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.343 2.36 21 17.067h-9.701l8.758 14.756A55.837 55.837 0 0 1 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .706-3.374 3.477-5.515Z",
    fill: "#227FBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.525 3.081 18.305 16H9.41l9.532 15.902A58.62 58.62 0 0 1 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .564-2.693 2.66-4.794Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.065 10.499a3.66 3.66 0 0 0-.065.688C1 13.293 2.79 15 5 15s4-1.707 4-3.813c0-.104-.004-.208-.013-.31C8.772 12 8.038 12.953 7.03 13.5l-.298-.381 1.077-.44-1.077-.44.704-.9-1.162.137.143-1.118-1 .726L5.026 10l-.392 1.085-1-.726.143 1.118-1.162-.137.704.9-1.077.44 1.077.44-.283.361c-1.098-.612-1.863-1.708-1.97-2.982ZM5 19l.577 1.846L7 19.537l-.424 1.887L8.464 21l-1.31 1.423L9 23l-1.846.577L8.463 25l-1.888-.424L7 26.465l-1.423-1.31L5 27l-.577-1.846L3 26.463l.424-1.887L1.536 25l1.31-1.423L1 23l1.846-.577L1.536 21l1.888.424L3 19.535l1.423 1.31L5 19Z",
    fill: "#fff"
  }));
};

export default SvgNpl;